/* This is a mst-gql generated file, don't modify it manually */
/* eslint-disable */
/* tslint:disable */
// @ts-nocheck

import { types } from 'mobx-state-tree'
import { QueryBuilder } from 'mst-gql'
import { ModelBase } from './ModelBase'
import { RootStoreType } from './index'

/**
 * DailyInspirationResponseReportsBase
 * auto generated base class for the model DailyInspirationResponseReportsModel.
 */
export const DailyInspirationResponseReportsModelBase = ModelBase.named('DailyInspirationResponseReports')
  .props({
    __typename: types.optional(types.literal('DailyInspirationResponseReports'), 'DailyInspirationResponseReports'),
    _id: types.identifier,
    createdAt: types.union(types.undefined, types.frozen()),
    reason: types.union(types.undefined, types.string),
    responseId: types.union(types.undefined, types.frozen()),
    updatedAt: types.union(types.undefined, types.frozen()),
    userId: types.union(types.undefined, types.frozen())
  })
  .views((self) => ({
    get store() {
      return self.__getStore<RootStoreType>()
    }
  }))

export class DailyInspirationResponseReportsModelSelector extends QueryBuilder {
  get _id() {
    return this.__attr('_id')
  }
  get createdAt() {
    return this.__attr('createdAt')
  }
  get reason() {
    return this.__attr('reason')
  }
  get responseId() {
    return this.__attr('responseId')
  }
  get updatedAt() {
    return this.__attr('updatedAt')
  }
  get userId() {
    return this.__attr('userId')
  }
}
export function selectFromDailyInspirationResponseReports() {
  return new DailyInspirationResponseReportsModelSelector()
}

export const dailyInspirationResponseReportsModelPrimitives =
  selectFromDailyInspirationResponseReports()._id.createdAt.reason.responseId.updatedAt.userId
